import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text, Localizer } from 'preact-i18n';

import { SHOOTER_MARK_CATEGORIES } from '../../lib/shooterMarkCategories';

// Officials-only drawer for marking a shooter (virrete/farlig/vanskelig +
// note). Marks are per club and follow the shooter across stevner. Category
// toggles save immediately; the note auto-saves with the standard 750ms delay.
@observer
class ShooterMarkEditor extends Component {
    constructor(props) {
        super(props);
        const { stores, userId } = props;
        const { shooterMarkStore } = stores;
        const mark = shooterMarkStore.getMarkForUser(userId);
        this.state = {
            categories: [...(mark?.categories || [])],
            note: mark?.note || '',
            saving: false,
        };
        this.noteTimer = null;
    }

    componentWillUnmount() {
        if (this.noteTimer) {
            clearTimeout(this.noteTimer);
        }
    }

    save = async ({ categories, note }) => {
        const { stores, conventionId, userId } = this.props;
        const { shooterMarkStore } = stores;
        this.setState({ saving: true });
        await shooterMarkStore.saveMark({
            convention: conventionId,
            user: userId,
            categories,
            note,
        });
        this.setState({ saving: false });
    }

    toggleCategory = (name) => () => {
        const { categories, note } = this.state;
        const next = categories.includes(name)
            ? categories.filter(cat => cat !== name)
            : [...categories, name];
        this.setState({ categories: next });
        this.save({ categories: next, note });
    }

    handleNote = (e) => {
        const note = e.target.value;
        this.setState({ note });
        if (this.noteTimer) {
            clearTimeout(this.noteTimer);
        }
        this.noteTimer = setTimeout(() => {
            this.save({ categories: this.state.categories, note });
        }, 750);
    }

    closeDrawer = () => {
        const { stores, drawerLevel } = this.props;
        const { appState } = stores;
        appState.toggleDrawer(false, drawerLevel);
    }

    render() {
        const { userName } = this.props;
        const { categories, note, saving } = this.state;
        return (
            <div class='d-flex flex-column px-3 py-3'>
                <h5 class='mb-1'>
                    <i class='fa-duotone fa-flag me-2' />
                    <Text id='shooterMark.title'>Marking of shooter</Text>: {userName}
                </h5>
                <small class='text-body-secondary mb-3'>
                    <Text id='shooterMark.officials-only-info'>Only visible to officials. The mark follows the shooter at all of this club's events.</Text>
                </small>
                <div class='d-flex flex-wrap mb-3'>
                    {SHOOTER_MARK_CATEGORIES.map(cat => {
                        const isActive = categories.includes(cat.name);
                        return (
                            <button
                                key={cat.name}
                                type='button'
                                class={`btn btn-sm ${isActive ? cat.btnClass : 'btn-outline-secondary'} me-2 mb-2`}
                                onClick={this.toggleCategory(cat.name)}
                            >
                                <i class={`${cat.icon} me-1`} />
                                <Text id={`shooterMark.category-${cat.name}`}>{cat.label}</Text>
                            </button>
                        );
                    })}
                </div>
                <label class='form-label mb-1' for='shooterMarkNote'>
                    <Text id='shooterMark.note'>Note</Text>
                </label>
                <Localizer>
                    <textarea
                        id='shooterMarkNote'
                        class='form-control mb-2'
                        rows='4'
                        maxLength='1000'
                        placeholder={<Text id='shooterMark.note-placeholder'>Why is this shooter marked?</Text>}
                        value={note}
                        onInput={this.handleNote}
                    />
                </Localizer>
                <small class='text-body-secondary mb-3'>
                    {saving ? <>
                        <i class='fa-duotone fa-spinner fa-spin me-1' />
                        <Text id='shooterMark.saving'>Saving...</Text>
                    </> : <>
                        <Text id='shooterMark.autosave-info'>Changes are saved automatically.</Text>
                    </>}
                </small>
                <div class='d-flex justify-content-end'>
                    <button type='button' class='btn btn-primary' onClick={this.closeDrawer}>
                        <Text id='shooterMark.done'>Done</Text>
                    </button>
                </div>
            </div>
        );
    }
}

export default ShooterMarkEditor;
